import { Suspense, useMemo } from 'react'

import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { DataTableLoading } from '@/catalog-apps/components/component-library/DataTableComponent'
import { DataTable } from '@/components/ui/DataTable'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { WorkspacesBreadcrumbs } from '../WorspacesBreadcrumbs'
import { useCurrentWorkspace } from '../useCurrentWorkspace'
import { WorkspaceDataAssetsFilters } from './WorkspaceDataAssetsTable/WorkspaceDataAssetsFilters'
import { workspaceDataAssetsTableColumns } from './WorkspaceDataAssetsTable/workspaceDataAssetsTableColumns'
import { getWorkspaceDataAssetsFilterOptions } from './WorkspaceDataAssetsTable/workspaceDataAssetsTableUtils'
import { useGetDataAssets } from '@/catalog-apps/components/SupportPanel/DataAssetsV2/useGetDataAssets'

export function WorkspaceDataAssetsPage() {
  return (
    <>
      <WorkspacesBreadcrumbs title="Data assets" />
      <QueryErrorBoundary errorMessage="Failed to fetch data assets">
        <Suspense fallback={<DataTableLoading />}>
          <WorkspaceDataAssetsPanelContent />
        </Suspense>
      </QueryErrorBoundary>
    </>
  )
}

function WorkspaceDataAssetsPanelContent() {
  const { app_id, project_id } = useCurrentWorkspace()
  const { data: summary } = useGetDataAssets({ appId: app_id, projectId: project_id })
  const filterOptions = useMemo(() => getWorkspaceDataAssetsFilterOptions(summary), [summary])

  return (
    <TablePageContainer>
      <DataTable
        columns={workspaceDataAssetsTableColumns}
        data={summary}
        filters={(table) => <WorkspaceDataAssetsFilters table={table} {...filterOptions} />}
        defaultSortColumnId="date"
        defaultSortDesc
      />
    </TablePageContainer>
  )
}
